

import Vue, { unref } from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex/types/helpers';
import {  FormFields, SelectModel} from  '@/models/repsol-template.model';
import { tUi } from '@/utils/translate';

@Component({
    name: 'RepsolFilterChipsComponent',
    components: {
            }
})

export default class RepsolFormPopupComponent extends Vue {
    isOpen = false;
    isValidForm = true;

    $refs!: {
        formRef: any
    }

    @Prop()
    headerText: string;

    @Prop()
    formFields:FormFields[];


    @Prop()
    rulesForm:any;

    @Prop()
    model: any;
    @Watch('model', {deep:true})
    changeModel(newModel, oldModel): void {
        this.cleanDates();
        this.eventAction('cambio', oldModel)
    }

    @Prop()
    isValid: boolean;

    @Prop()
    onlyRead: boolean;

    @Prop()
    popupWidth: string;

    @Prop()
    showMessage: boolean;

    @Prop()
    changeVisibility!: boolean;
    @Watch('changeVisibility')
    changeStatus(val: boolean): void {
        this.isOpen = val
    }

    translate(value: string, params?: Record<string, unknown>): string {
        return tUi(value, params);
    }

    translateItemText(value: any): string {
        if (value == null) {
            return '';
        }

        if (typeof value === 'string') {
            return this.translateUserProfileValue('', value);
        }

        if (typeof value === 'object') {
            const label = value.nombre ?? value.name ?? value.id ?? '';
            return this.translateUserProfileValue(value.id, label);
        }

        return this.translateUserProfileValue('', String(value));
    }

    translateUserProfileValue(profileId: any, profileName: any): string {
        const id = String(profileId ?? '').trim().toUpperCase();
        const name = String(profileName ?? '').trim().toLowerCase();

        if (id === 'ADM' || name === 'administrador' || name === 'administrator') {
            return this.translate('usuarios.profile_admin');
        }

        if (id === 'CEN' || name === 'administrador central' || name === 'central administrator' || name === 'central') {
            return this.translate('usuarios.profile_central_admin');
        }

        if (id === 'MESA' || name === 'operador mesa' || name === 'desk operator') {
            return this.translate('usuarios.profile_desk_operator');
        }

        if (id === 'MLECT' || name === 'operador mesa lectura' || name === 'desk read-only operator') {
            return this.translate('usuarios.profile_desk_readonly_operator');
        }

        if (id === 'CONTR' || name === 'operador contraparte' || name === 'counterparty operator') {
            return this.translate('usuarios.profile_counterparty_operator');
        }

        if (id === 'DER' || id === 'DERIV' || name === 'operador derivados' || name === 'derivatives operator') {
            return this.translate('usuarios.profile_derivatives_operator');
        }

        if (id === 'DERL' || id === 'DERIVL' || name === 'operador derivados lectura' || name === 'derivatives read only operator') {
            return this.translate('usuarios.profile_derivatives_readonly_operator');
        }

        return this.translate(String(profileName));
    }

    translatedItems(items: any[] | undefined): any[] {
        if (!Array.isArray(items)) {
            return [];
        }

        return items.map((item) => {
            if (item == null || typeof item !== 'object') {
                return item;
            }

            return {
                ...item,
                nombre: this.translateItemText(item),
                name: this.translateItemText(item),
            };
        });
    }

    cleanDates():void{
        this.formFields.forEach(ff => {

            if(ff.as == 'date'){
                let modelValue = this.model[ff.name];
                if(modelValue && modelValue.indexOf("T")){
                    this.model[ff.name] = modelValue.split("T")[0];
                }
            }
        });
    }

    eventAction(action:string, oldModel?:any): void{
        this.$emit("eventAction", action, this.model, oldModel);
    }
    
    tableEventAction(action:string, item:any): void {
        this.$emit("eventAction", "tableEventAction", this.model, action, item);
    }

    public mounted() {
        const popupMain = document.getElementById("popup-main");
        if(popupMain != null) {
            popupMain.style.maxWidth = this.popupWidth == undefined ? "800" : this.popupWidth + "px";
        }
    }

    public rules(campo: string){
            const baseRules = this.rulesForm && this.rulesForm[campo] ? this.rulesForm[campo] : [(field: string) => true];

            if (campo === 'destinatariosNotificacionAltura' && this.isEnviarAlturaDisabled) {
                const requiredRule = this.required();
                if (Array.isArray(baseRules)) {
                    return [...baseRules, requiredRule];
                }
                return [baseRules, requiredRule];
            }

            return baseRules;
    }

    async manageForm() {
        if (!this.isValidForm) {
            this.$refs.formRef.validate()
            return
        }
        let response: any;
        //this.setLoader(true)

        this.eventAction('salvar');
    }

    private required() {
        return (value: any) => {
            if (Array.isArray(value)) {
                return value.length > 0 || this.translate('common.required');
            }
            if (value === 0) {
                return true;
            }
            return !!value || this.translate('common.required');
        };
    }

    private isNoValue(value: any): boolean {
        if (value === false || value === 0) {
            return true;
        }
        if (value === null || value === undefined) {
            return false;
        }
        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            return normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'n';
        }
        return false;
    }

    get isEnviarAlturaDisabled(): boolean {
        const value = this.model?.enviarAltura;
        return this.isNoValue(value);
    }


}

Vue.component('repsol-form-popup', RepsolFormPopupComponent);
